'use client'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const VaultV2TimelocksError = () => {
  return (
    <div data-testid="vault-v2-timelocks-error">
      <ErrorServiceUnavailable minHeight="100px" />
    </div>
  )
}

export default VaultV2TimelocksError
